import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableComponent from 'components/partials/table-component/table-component';
import Loader from 'components/partials/loader/loader';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import { getGoalCriticalElementsTableSettings } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goal/goal-tabs/goal-critical-elements-table-settings';

import api from 'api';

import Icons from 'assets/icons';

const CriticalElementsTab = ({ data, clientId, userId }) => {
  const [criticalElements, setCriticalElements] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCriticalElements = async () => {
      if (!data?.id || !clientId || !userId) return;

      setLoading(true);
      try {
        const response = await api.getGoalCriticalElements({
          userId,
          goalId: data.id,
        });

        setCriticalElements(response?.data || []);
      } catch (error) {
        console.error('Error fetching linked critical elements:', error);
        setCriticalElements([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCriticalElements();
  }, [data?.id, userId]);

  const handleViewDetails = (criticalElementId) => {
    const year = data.enteringClassYear;

    navigate(
      `/admin/clients/${clientId}/critical-elements/${year}/${criticalElementId}`
    );
  };

  const columns = getGoalCriticalElementsTableSettings(handleViewDetails);

  if (!criticalElements?.length && !loading) {
    return (
      <EmptySpaceContent
        image={<Icons.EmptyImage customClass="w-[120px] h-[120px]" />}
        text="No linked Critical Elements found"
      />
    );
  }

  return (
    <>
      <Loader
        loading={loading}
        overlay="white"
        customClass="opacity-75"
        fullScreen={false}
      />

      <TableComponent
        columns={columns}
        data={criticalElements}
        customHeight="max-h-[50vh]"
        pagination={false}
      />
    </>
  );
};

export default CriticalElementsTab;
